export default "__VITE_ASSET__CjlryWsl__"